export default __webpack_public_path__ + "images/34ab1c0cc12d64991fa6c8e4c537877a.svg";